import { render, staticRenderFns } from "./u-pagination-filled-tile.vue?vue&type=template&id=64ae7b7c&scoped=true&"
import script from "./u-pagination-filled-tile.vue?vue&type=script&lang=js&"
export * from "./u-pagination-filled-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ae7b7c",
  null
  
)

export default component.exports